import React, { useState } from 'react';
import { DataTable, Icon, Tag, Font } from 'pepsico-ds';
import DownArrow from "../../assets/DownArrow.svg";
import UpArrow from "../../assets/UpArrow.svg";
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'

const CmaTable = ({ tableData, cmaColumns }) => {
  const [rowSelection, setRowSelection] = useState({});
  return (
    <>
      {/* <style>{`
        .cma-table-wrapper table {
          border-collapse: collapse;
        }
        .cma-table-wrapper th, .cma-table-wrapper td {
          border-bottom: 1px solid #d1d5db !important;
        
        }
        .cma-table-wrapper thead th {
          border-top: 1.5px solid #d1d5db !important;
          background: #fff;
          z-index: 2;
          
        }
        .cma-table-wrapper .forecast-row td {
          background: #f5f6fa !important;
          
        }
        .divider.divider-horizontal.header-divider {
          height: 0 !important;
          box-shadow: none !important;
        }
        .datatable #content table tbody tr td{
        box-shadow: none !important;
        }
        .datatable #content table thead tr > th{
        box-shadow: none !important;
        }
        .column-header{
        background: #f3f8fd !important;
        } 
      `}</style> */}
      {/* <div className="cma-table-wrapper"> */}
      <div className="resins-intelligence-cma-table">
        <DataTable
          columns={cmaColumns}
          data={tableData}
          isExpandable={false}
          enableSorting={false}
          pageIndex={0}
          pageSize={10}
          rowSelectionStateUpdater={setRowSelection}
          selection="single"
          size="large"
          tableDescription={false}
          tableHeader={false}
          showSearchOption={false}
          showColumnFilters={false}
        />
      </div>
    </>
  );
};

export default CmaTable;